export enum ViewModeEnum {
    SINGLE = "single",
    WEBVR = "webVR",
    STEREO = "stereo",
    QUAD = "quad"
}
